module.exports = __webpack_public_path__ + "static/img/RP-U24V5_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-U24V5_1.png
// module id = jcru
// module chunks = 0